import { Text } from "@nova/protobuf"
import { zoomToShowText } from "features/map/zoom/thunks"
import { createText } from "features/pubsub/entityActions/cubes/text"
import store from "integrations/redux/store"
import { selectUserID } from "user/profile/selectors"
import { createDuplicatedEntityName } from "../module"
import { decideTakeSnapshotOfSecondaryLayer } from "features/map/control/module"

export const zoomToText = (entity: Text) => {
    decideTakeSnapshotOfSecondaryLayer()
    store.dispatch(
        zoomToShowText({
            point: [entity.longitude, entity.latitude],
            fontSize: entity.fontSize,
            latitude: entity.latitude,
        })
    )
}

export const duplicateText = (entity: Text) => {
    const userId = selectUserID(store.getState())
    if (!userId) return

    store.dispatch(
        createText({
            data: {
                text: entity.text,
                rotation: entity.rotation,
                longitude: entity.longitude,
                latitude: entity.latitude,
                baseFontSize: entity.baseFontSize,
                fontSize: entity.fontSize,
                color: entity.color,
                bold: entity.bold,
                outlineColor: entity.outlineColor,
                outlineWidth: entity.outlineWidth,
                parentId: entity.parentId,
                createdBy: { userId },
            },
            context: {
                name: createDuplicatedEntityName(entity.name),
                isDuplicated: true,
            },
        })
    )
}
